import { fetchData } from '../utils';

/**
 *
 * @param {number} lat Floating point number that represents a latitude coordinate
 * @param {number} lon Floating point number that represents a longitude coordinate
 * @param {string} baseUrl Base url for podlet
 * @return {Array<Location>} Array of location objects
 */

export async function getLocationData(
    lat: number,
    lon: number,
    baseUrl: string,
) {
    const url = buildMapServiceUrl(lat, lon, baseUrl);
    try {
        const response = await fetchData(url);
        return response.locationsNearby as Location[];
    } catch (e) {
        throw new Error(`Unable to derive areaId - error: ${e}`);
    }
}

function buildMapServiceUrl(lat: number, lon: number, baseUrl: string) {
    return `${baseUrl}/map/?lat=${lat}&lon=${lon}`;
}

export type Location = {
    areaId: number;
    areaType: number;
    name: string;
    coordinate: {
        x: number;
        y: number;
        projection: string;
        valid: boolean;
    };
    metersToCenter: number;
};
/**
 *
 * @param locations Array of Location objects
 * @returns array of Keyword objects matching each location with a valid areaId
 */
export function getAreaId(locations: Location[]) {
    if (locations && locations.length > 0) {
        // areaType reference: https://confluence.schibsted.io/pages/viewpage.action?pageId=22658194
        const regionAreaId = locations.find((i) => i.areaType === 6)?.areaId;
        const municipalityAreaId = locations.find((i) => i.areaType === 16)
            ?.areaId;
        const cityAreaId = locations.find((i) => i.areaType === 10)?.areaId;

        const areaIds = [
            regionAreaId
                ? { 'no-sno-finn-region': regionAreaId.toString() }
                : undefined,
            municipalityAreaId
                ? { 'no-sno-finn-municipality': municipalityAreaId.toString() }
                : undefined,
            cityAreaId
                ? { 'no-sno-finn-city': cityAreaId.toString() }
                : undefined,
        ].filter((i) => i !== undefined);

        return areaIds;
    } else return [];
}

export async function getGeoFilterLocationKeywords(
    filter: any,
    baseUrl: string,
) {
    const { geoLocationName, location } = filter;
    if (geoLocationName && !location) {
        try {
            const {
                //@ts-ignore
                lat: [latVal],
                lon: [lonVal],
            } = filter;
            const locations = await getLocationData(
                Number(latVal),
                Number(lonVal),
                baseUrl,
            );
            const areaIds = getAreaId(locations);
            const geoFilterLocationKeywords = areaIds.reduce((acc, cur) => {
                return { ...acc, ...cur };
            }, {});
            return geoFilterLocationKeywords;
        } catch (e) {
            console.error('Error occurred: ', e);
            return {};
        }
    } else {
        return {};
    }
}
